import { render } from "./DetailsRestaurant.vue?vue&type=template&id=9f4463d6"
import script from "./DetailsRestaurant.vue?vue&type=script&lang=js"
export * from "./DetailsRestaurant.vue?vue&type=script&lang=js"

import "./DetailsRestaurant.vue?vue&type=style&index=0&id=9f4463d6&lang=css"

import exportComponent from "/srv/guestwaiterreportingfront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__